<!-- 登录(绑定角色) -->
<template>
  <popup-frame ref="popup">
    <div :class="$style.login">
      <bind-form
        ref="form"
        :login-type="loginType"
        @bind-success="handleBindSuccess"
      />
    </div>
  </popup-frame>
</template>

<script>
import BindForm from "./BindForm";
import { PopupFrame } from "@/components/widgets";

export default {
  name: "TheLogin",
  components: { BindForm, PopupFrame },
  data() {
    return {
      /**
       * 场景来源：1 仅登录, 2 预约领礼包
       */
      loginType: 1
    };
  },
  methods: {
    /**
     * 显示登录弹窗并初始化状态
     * @param {number} type 场景来源：1 仅登录, 2 登录后立即领礼包
     */
    show(type) {
      if (type) this.loginType = type;
      this.$refs.popup.show();
      // 重置表单
      if (this.$refs.form) this.$refs.form.reset();
    },
    /**
     * 登录后回调返回
     * @param {number} type 场景来源：1 仅登录, 2 预约领礼包
     **/
    handleBindSuccess(type) {
      this.$emit("login-success", type);
      this.$refs.popup.hide();
    }
  }
};
</script>

<style lang="less" module>
.login {
  padding-top: 0.1rem;

  // 标题
  &::before {
    .size(5.16rem, 0.42rem);
    .background-fill("./images/title.png");

    content: "";
    display: block;
    margin: 0 auto;
  }
}
</style>
